import Headroom from 'headroom.js';

const el = document.querySelector('.banner');

const config = {
  offset : 10,
};

function init() {
  let headroom = new Headroom(el, config);
  headroom.init();
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/headroom.js